// import react from 'react';
import underline from '../images/vectors/underline.png';
import Redline from '../images/vectors/redline.png'
import { useNavigate } from 'react-router-dom';
const SaveMoney = () => {
  const navigate = useNavigate();


  const handleNavigation = () => {
    navigate('/check-eligibility');
  };
    return (
        <div>
  <div className="h-[212px] md:h-[340px] bg-[#003DB7]">
   <div className="max-w-4xl mx-auto">
  <div className="absolute md:w-[581px] left-1/2 transform -translate-x-1/2 font-inter font-semibold text-[20px] md:text-[40px] flex flex-col items-center text-center text-white mt-[20px]">
    <span className="block md:inline ">
      എവിടെ എല്ലാം നിങ്ങളുടെ പണം
    </span>
    <span className="block md:inline">
      നഷ്ട്ടമാവാൻ സാധ്യത ഉണ്ട്?
    </span>
    <img
      src={underline}
      alt="line"
      className="w-[100px] md:w-[270px] mx-auto md:mx-0 md:ml-[80px] mt-1"
    />
  </div>

    </div>

    <div>
      <div className="flex flex-wrap justify-center gap-3.5 mb-6 px-4 ">
        <div className="w-full sm:w-[268px] h-[170.19px] md:h-[191.19px] max-w-[calc(50%-0.875rem)] sm:max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow-lg shadow-gray-500/50 mt-[185px] md:mt-[290px]">
          <h3 className="text-xl font-bold text-blue-600 mb-2 text-center mt-[20px]">
            Visit Visa
          </h3>
          <div className="relative flex justify-center">
            <p className="text-gray-500 justify-center">580 DHS</p>
            <img
              src={Redline}
              alt="line"
              className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[60px]"
            />
          </div>
        </div>

        <div className="w-full sm:w-[268px] h-[170.19px] md:h-[191.19px] max-w-[calc(50%-0.875rem)] sm:max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow-lg shadow-gray-500/50 mt-[185px] md:mt-[290px]">
          <h3 className="text-xl font-bold text-blue-600 mb-2 text-center mt-[20px]">
            Attestation
          </h3>
          <div className="relative flex justify-center">
            <p className="text-gray-500 justify-center">420 DHS</p>
            <img
              src={Redline}
              alt="line"
              className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[60px]"
            />
          </div>
        </div>

        <div className="w-full sm:w-[268px] h-[170.19px] md:h-[191.19px] max-w-[calc(50%-0.875rem)] sm:max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow-lg shadow-gray-500/50 mt-[10px] md:mt-[290px]">
          <h3 className="text-xl font-bold text-blue-600 mb-2 text-center mt-[20px]">
            File Open
          </h3>
          <div className="relative flex justify-center">
            <p className="text-gray-500 justify-center">250 DHS</p>
            <img
              src={Redline}
              alt="line"
              className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[60px]"
            />
          </div>
        </div>

        <div className="w-full sm:w-[268px] h-[170.19px] md:h-[191.19px] max-w-[calc(50%-0.875rem)] sm:max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow-lg shadow-gray-500/50 mt-[10px] md:mt-[290px]">
          <h3 className="text-xl font-bold text-blue-600 mb-2 text-center mt-[20px]">
            Entry Permit
          </h3>
          <div className="relative flex justify-center">
            <p className="text-gray-500 justify-center">520/1250 DHS</p>
            <img
              src={Redline}
              alt="line"
              className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[60px]"
            />
          </div>
        </div>
      </div>

      <div className="flex flex-wrap justify-center gap-3.5 mb-8 px-4">
        <div className="w-full sm:w-[268px] h-[170.19px] md:h-[191.19px] max-w-[calc(50%-0.875rem)] sm:max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow-lg shadow-gray-500/50">
          <h3 className="text-xl font-bold text-blue-600 mb-2 text-center mt-[20px]">
            Medical
          </h3>
          <div className="relative flex justify-center">
            <p className="text-gray-500 justify-center">320 DHS</p>
            <img
              src={Redline}
              alt="line"
              className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[60px]"
            />
          </div>
        </div>

        <div className="w-full sm:w-[268px] h-[170.19px] md:h-[191.19px] max-w-[calc(50%-0.875rem)] sm:max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow-lg shadow-gray-500/50">
          <h3 className="text-xl font-bold text-blue-600 mb-2 text-center mt-[20px]">
            Emirates ID
          </h3>
          <div className="relative flex justify-center">
            <p className="text-gray-500 justify-center">380 DHS</p>
            <img
              src={Redline}
              alt="line"
              className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[60px]"
            />
          </div>
        </div>

        <div className="w-full sm:w-[268px] h-[170.19px] md:h-[191.19px] max-w-[calc(50%-0.875rem)] sm:max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow-lg shadow-gray-500/50">
          <h3 className="text-xl font-bold text-blue-600 mb-2 text-center mt-[20px]">
            Visa Stamping
          </h3>
          <div className="relative flex justify-center">
            <p className="text-gray-500 justify-center">550 DHS</p>
            <img
              src={Redline}
              alt="line"
              className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[60px]"
            />
          </div>
        </div>

        <div className="w-full sm:w-[268px] h-[170.19px] md:h-[191.19px] max-w-[calc(50%-0.875rem)] sm:max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow-lg shadow-gray-500/50">
          <h3 className="text-xl font-bold text-blue-600 mb-2 text-center mt-[20px]">
            Status Change
          </h3>
          <div className="relative flex justify-center">
            <p className="text-gray-500 justify-center">650 DHS</p>
            <img
              src={Redline}
              alt="line"
              className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[60px]"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div className="absolute left-1/2 -translate-x-1/2 mt-[720px] md:mt-[400px] flex flex-col items-center justify-center text-center px-4">
    <p className="text-2xl md:text-7xl flex flex-col mb-4 md:mb-6">
      <span className="whitespace-nowrap">നിങ്ങൾക്ക് 4000 AED</span>
      <span>
        <span className="font-bold">സാലറി കോൺട്രാക്ടിൽ</span> ഉണ്ടോ?
      </span>
    </p>
    <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-8 w-full md:w-auto">
      <button onClick={handleNavigation} className="bg-green-500 text-white px-4 md:px-8 py-2 rounded-[50px] hover:bg-green-600 w-full md:w-[348px] h-[45px] md:h-[55px] text-base md:text-lg">
        YES
      </button>
      <button className="bg-blue-500 text-white px-4 md:px-8 py-2 rounded-[50px] hover:bg-blue-600 w-full md:w-[263px] h-[45px] md:h-[55px] text-base md:text-lg">
        NO
      </button>
    </div>
</div>
</div>
    );  
};
export default SaveMoney;